import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'

const AreaGestion = lazy(() => import('./view/AreaGestion'))

export const areasRoutesMap = {
  gestion: {
    path: '/areas/gestion',
    name: 'Áreas de Cocina',
    action: 'GESTION_DE_AREAS',
  },
}

const areasRoutes = [
  {
    path: areasRoutesMap.gestion.path,
    element: <AreaGestion />,
    auth: authRoles.admin,
  },
]

export default areasRoutes
